import 'babel-polyfill'
import Vue from 'vue'
import i18n from '@/i18n' // should be included, probably (unless you're not using i18n translations in any components that will be loaded here)
import { VPopover, VTooltip } from 'v-tooltip'
import globalVue from '@/mixins/global'
import { registerGlobalBus, globalEvent } from '@/utils/globalBus'
import customMessage from '@/components/base/flash-message-custom/custom-message'
import FlashMessage from '@smartweb/vue-flash-message'
import baseFullLoader from '@/components/base/base-full-loader'
import loaderFull from '@/components/base/loader/base-full-loader-plugin'
// import '@/config/validation/vee-validate-config' // include if needed, for example if you have any input form that needs to be validated
require('@/assets/styles/main.scss')

// require('@/config/axios') // include if needed, probably is
registerGlobalBus(Vue)
Vue.prototype.$globalEvent = globalEvent()

Vue.config.productionTip = false

/**
 * If you copy this to another entry point, check if you're using proper element id in spark templates
 */
Vue.component('v-popover', VPopover)
Vue.component('v-tooltip', VTooltip)
Vue.component('customMessage', customMessage)
Vue.component('baseFullLoader', baseFullLoader)
Vue.use(FlashMessage)
Vue.use(loaderFull)
Vue.mixin(globalVue)

if (document.getElementById('hc-vue')) {
  const requireComponent = require.context('./views/', false, /view-[^\\]*\.vue$/)
  requireComponent.keys().forEach((fileName) => {
    const componentConfig = requireComponent(fileName)
    const componentName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1') // TODO Normalize component names
    Vue.component(componentName, componentConfig.default || componentConfig)
  })

  new Vue({
    i18n,
    el: '#hc-vue'
  }).$mount('#hc-vue')
}
